import React from 'react';
// Components
import AffiliateCommissionsReportTable from 'components/common/AffiliateCommissionsReportTable/AffiliateCommissionsReportTable';

const AffiliateCommissionsReport = (): JSX.Element => {
  return <AffiliateCommissionsReportTable />;
};

export default AffiliateCommissionsReport;
